import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { FormattedMessage } from "react-intl";

export const RemoteSessionEnded: FC = () => {
  return (
    <Grid>
      <Typography>
        <FormattedMessage id="remoteAccess.sessionEnded" />
      </Typography>
    </Grid>
  );
};
